import ListLayout from "../../../components/layout/main/ListLayout";
import { PageCard } from "../../../styles/CommonStyles";
import { useState } from "react";
import ModalLayout from "../../../components/layout/main/ModalLayout";
import Tooltip from "../../../components/common/utils/Tooltip";
import { AddIcon } from "../../../styles/main/setting";
import { useGetSuggestions } from "../../../core/services/react-query/setting/suggestion";
import SuggestionListing from "../../../components/main/setting/suggestion/SuggestionListing";
import SuggestionModal from "../../../components/main/setting/suggestion/SuggestionModal";

const SuggestionsPage = () => {
    const { data: suggestions, isLoading } = useGetSuggestions();

    const [suggestionModalOpen, setSuggestionModalOpen] = useState(false);

    const closeSuggestionModal = () => setSuggestionModalOpen(false);
    const openSuggestionModal = () => setSuggestionModalOpen(true);

    return (
        <ListLayout>
            <PageCard>
                <Tooltip content={'add-suggestion'}>
                    <div onClick={openSuggestionModal}>
                        <AddIcon size={24} />
                    </div>
                </Tooltip>

                <SuggestionListing
                    suggestions={suggestions}
                    isLoading={isLoading}
                />
            </PageCard>

            <ModalLayout
                width={'700px'}
                open={suggestionModalOpen}
                onClose={closeSuggestionModal}
            >
                <SuggestionModal
                    existingSuggestions={suggestions}
                    onSuccess={closeSuggestionModal}
                />
            </ModalLayout>
        </ListLayout>
    );
};

export default SuggestionsPage;